export default __webpack_public_path__ + "static/redpoint-704e6f970abb9997c8e2a5da625fa4bd.png";